import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const sidebar = (sidebarOpen: boolean) => css`
  display: flex;
  flex-direction: column;
  width: ${sidebarOpen ? '260px' : '84px'};
  pointer-events: all;
  color: ${colors.gray.light};
  background-color: ${colors.secondary.default};
  height: 100vh;
  box-sizing: border-box;
  transition:
    transform 0.3s ease 0s,
    width 0.3s ease 0s;
`;

export const hintPopup = { popper: { width: 'auto' } };

export const menu = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto !important;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const sidebarToggle = css`
  display: flex;
  color: white;
  flex-direction: row;
  align-items: center;
  padding: 20px 20px 10px;
  justify-content: space-between;

  > svg {
    cursor: pointer;
    height: 16px;
    margin-left: 14px;
  }
`;

export const badgeCircle = (color: string) => css`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${color};
  margin-left: 15px;
`;

export const sidebarScroll = (open: boolean) => css`
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: ${open ? 'stable' : 'unset'};

  ::-webkit-scrollbar {
    width: 16px;
    background: #18182e;
  }

  ::-webkit-scrollbar-thumb {
    border: 5px solid transparent;
    border-radius: 100px;
    background-color: #5d7186;
    background-clip: content-box;
  }
`;
